<div class="forgot-container">
  <div class="forgot-card">
    <div class="home-navigation">
      <button mat-button routerLink="/login" class="home-link">
        <mat-icon>chevron_left</mat-icon>
        Back to Login
      </button>
    </div>

    <div class="forgot-header">
      <h1>Forgot Password</h1>
      <p>Enter your email and we'll send you a link to reset your password</p>
    </div>

    <div *ngIf="!submitted">
      <form [formGroup]="form" (ngSubmit)="submit()">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Email</mat-label>
          <input matInput formControlName="email" type="email" placeholder="Enter your email" />
          <mat-error *ngIf="form.get('email')?.touched && form.get('email')?.invalid">
            {{ getErrorMessage('email') }}
          </mat-error>
        </mat-form-field>

        <button mat-raised-button color="primary" type="submit" class="full-width submit-button"
          [disabled]="form.invalid || isLoading">
          <mat-spinner diameter="20" *ngIf="isLoading"></mat-spinner>
          <span *ngIf="!isLoading">{{ isLoading ? 'Sending...' : 'Send reset link' }}</span>
        </button>
      </form>
    </div>

    <div *ngIf="submitted" class="success-message">
      <mat-icon>mark_email_read</mat-icon>
      <p>If an account exists for this email, we've sent a reset link. Please check your inbox and spam folder.</p>
      <button mat-button routerLink="/login" color="primary">Back to Login</button>
    </div>

    <div class="back-link">
      <p>Remember your password? <a routerLink="/login">Sign in</a></p>
    </div>
  </div>
</div>
